import { Text } from 'components';
import { theme } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Arrows } from '../../components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 65px 0;
  position: relative;

  @media (min-width: 1024px) {
    .mobile-heading {
      display: none;
    }
  }

  @media (max-width: 1024px) {
    margin: 148px 0 35px;

    h4 {
      font-size: 30px;
      color: ${theme.SECONDARY};
      font-weight: 500;
      margin: 0 17px 28px;
    }
  }
`;

const BgsContainer = styled.div`
  position: absolute;
  width: 100vw;
  display: flex;
  flex-direction: column;
  z-index: 1;
  top: -20px;
`;

const RedBg = styled.div`
  height: 563px;
  width: 1280px;
  background-color: ${theme.SECONDARY};
  align-self: center;

  @media (max-width: 1024px) {
    margin-top: 4px;
    width: 100vw;
    height: 397px;
  }
`;

const PurpleBg = styled.div`
  height: 183px;
  width: 100%;
  background-color: ${theme.DARK_PURPLE};

  @media (max-width: 1024px) {
    width: 100vw;
    height: 102px;
  }
`;

const ContentContainer = styled.div`
  z-index: 2;
  display: flex;
  flex-direction: column;
`;

const ScrollContainer = styled.div`
  ${navigator.platform !== 'Win32' ? 'overflow-x: scroll;' : 'overflow-x: hidden;'}
  padding-left: ${(props) => props.extraPad};
  display: flex;
  margin-top: 40px;
  height: 490px;
  padding-top: 80px;

  @media (max-width: 1024px) {
    margin-top: 25px;
    padding-left: 17px;
    overflow-x: scroll;
  }
`;

const HeaderRow = styled.div`
  display: flex;
  width: 1140px;
  align-self: center;
  position: relative;

  @media (max-width: 1024px) {
    width: 100vw;
  }
`;

const AthleteFocusHeader = styled.div`
  margin-top: 20px;
  margin-left: 15px;

  h4 {
    font-size: 30px;
    font-weight: 500;
    color: ${theme.SECONDARY};
  }

  h3 {
    font-size: 72px;
    line-height: 54px;
    margin-top: 19px;
    letter-spacing: -3.5px;
  }

  @media (max-width: 1024px) {
    margin-top: 0;

    .desktop-h3 {
      display: none;
    }

    .mobile-h3 {
      margin-top: 20px;
      h3 {
        margin-top: 0;
        font-size: 48px;
        line-height: 37.44px;
        letter-spacing: -1.5px;
        color: white;
      }
    }

    h4 {
      display: none;
    }
  }

  @media (min-width: 1024px) {
    .mobile-h3  {
      display: none;
    }
  }
`;

const HeaderText = styled(Text)`
  font-family: CeraStencil;
  color: #fff;
  width: 409px;
  font-size: 48px;
  font-weight: 700;
  line-height: 37px;
  text-indent: 25px;

  .mobile-line-break {
    @media (min-width: 1024px) {
      display: none;
    }
  }

  .web-line-break {
    @media (max-width: 1024px) {
      display: none;
    }
  }

  @media (max-width: 1024px) {
    font-size: 40px;
    line-height: 33px;
    width: 213px;
  }
`;
const AchievementWrapper = styled.div`
  margin-top: 30px;
  margin-left: 20px;

  .achievement  {
    font-family: CeraPro;
    font-size: 18px;
    font-weight: 400;
    line-height: 20px;
    color: #fff;
  }

  @media (max-width: 1024px) {
    .achievement {
      font-size: 14px;
      line-height: 18px;
    }
  }
`;

const AthleteItem = styled.div`
  width: 440px;
  height: 410px;
  background-color: #000;
  margin-right: 110px;
  position: relative;

  img {
    width: 290px;
    height: 290px;
    margin-top: -80px;
    margin-left: 220px;
  }

  .athlete-name {
    position: absolute;
    width: 300px;
    top: 70px;
    left: 15px;
    font-family: CeraStencil;
    font-size: 64px;
    font-weight: 700;
    line-height: 49px;
    color: #fff;
  }

  @media (max-width: 1024px) {
    width: 240px;
    margin-right: 30px;
    height: 310px;
    margin-right: 16px;

    img {
      width: 196px;
      height: 196px;
      margin-left: 16px;
      margin-bottom: 5px;
    }

    .athlete-name  {
      font-size: 28px;
      line-height: 26px;
      width: 180px;
      text-indent: 20px;
    }
  }
`;

const ArrowsContainer = styled.div`
  position: absolute;
  right: -17px;
  top: 68px;
`;

const AthleteFocus = (props) => {
  const { t } = useTranslation();
  const [extraPad, setExtraPad] = useState('0px'),
    scrollRef = useRef(null);

  useEffect(() => {
    handleExtraPad();
  }, []);

  function handleExtraPad() {
    setExtraPad(`${(window.innerWidth - 1140) / 2}px`);
  }

  const topAthletes = [
    //PLACEHOLDER
    {
      name: 'JAHVON BLAIR',
      image: require('assets/images/pogba.png'),
      achievements: ['DEFENSIVE PLAYER OF THE YEAR', 'ROOKIE OF THE YEAR', 'SIXTH MAN OF THE YEAR']
    },
    {
      name: 'NATE REUVERS',
      image: require('assets/images/pogba.png'),
      achievements: ['MOST IMPROVED PLAYER']
    },
    {
      name: 'SWAMP WATERS',
      image: require('assets/images/pogba.png'),
      achievements: ['OFFENSIVE PLAYER OF THE YEAR', 'SAVED A CAT THAT ONE TIME']
    },
    {
      name: 'PLACE HOLDER',
      image: require('assets/images/pogba.png'),
      achievements: ['WHO?', 'UHHHHHHHHH']
    }
  ];

  return (
    <Container>
      <ContentContainer>
        <HeaderRow>
          <AthleteFocusHeader>
            <HeaderText>
              {t('website.led')} <br className="web-line-break" /> {t('website.byTopAthletes')}
            </HeaderText>
          </AthleteFocusHeader>

          <ArrowsContainer>
            <div className="absolute-arrows">
              <Arrows col="white" elem={scrollRef} />
            </div>
          </ArrowsContainer>
        </HeaderRow>

        <ScrollContainer extraPad={extraPad} ref={scrollRef}>
          {topAthletes.map((x, i) => (
            <AthleteItem>
              <img src={x.image} alt="" />

              <Text className="athlete-name">{x.name}</Text>
              <AchievementWrapper>
                {x.achievements.map((x, i) => (
                  <Text className="achievement">{x}</Text>
                ))}
              </AchievementWrapper>
            </AthleteItem>
          ))}
        </ScrollContainer>
      </ContentContainer>

      <BgsContainer>
        <RedBg />
        <PurpleBg />
      </BgsContainer>
    </Container>
  );
};

export default AthleteFocus;
